<template>
    <p class="mt-2 text-sm text-red-600" id="email-error">{{ errors.join(' | ') }}</p>
</template>

<script>
    export default {
        name: "FormError",
        props: {
            errors: Array
        }
    }
</script>

<style scoped>

</style>
